export default "__VITE_ASSET__SuMnelbh__"